import { useState } from "react";
import { LessonPreview } from "./LessonPreview";
import { useParams } from "react-router-dom";
import { Box, CircularProgress } from "@material-ui/core";
import { LocaleSelect } from "routes/createContent/components/LocaleSelect";
import useGetLesson from "../../api/useGetLesson";
import { isUsMarket } from "utils/market";

export const LessonPreviewParent: React.VFC = () => {
  const { id } = useParams<{ id: string }>();
  const [locale, setLocale] = useState(isUsMarket ? "en-US" : "sv-SE");
  const { data: lesson, isLoading } = useGetLesson(Number(id), locale);

  return (
    <div>
      <Box mb={3}>
        <LocaleSelect value={locale} onChange={setLocale} />
      </Box>

      {isLoading && <CircularProgress />}
      {!isLoading && lesson && <LessonPreview lesson={lesson} />}
    </div>
  );
};
